import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import Chat from "@material-ui/icons/Chat";
import SportsEsportsIcon from "@material-ui/icons/SportsEsports";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
// core components
import GridContainer from "components/MaterialKit/Grid/GridContainer.js";
import GridItem from "components/MaterialKit/Grid/GridItem.js";
import InfoArea from "components/MaterialKit/InfoArea/InfoArea.js";

import styles from "assets/jss/material-kit-react/views/Home/aboutSectionStyle.js";

const useStyles = makeStyles(styles);

export default function AboutSection() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <h2 className={classes.title}>About our platform</h2>
          <h5 className={classes.description}>
            The most suitable platform for any gamer.Gamers can post their
            gaming content, follow/unfollow other gamers and rate other gamer's
            posts and comment on them. Our platform also provides easy and fast
            login feature using google and facebook.Our platform allows users to
            live stream their content with also an option to record it so that
            user can post it whenever required.
          </h5>
        </GridItem>
      </GridContainer>
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Live Chat"
              description="Our platform provides a unique chatting platorm, so that you can chat with all your peers"
              icon={Chat}
              iconColor="info"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Live Stream and Stream Recording"
              description="Our platform allows users to live stream their content with also an option to record it so that user can post it whenever required. Also other prople can view that post if they follow that user."
              icon={SportsEsportsIcon}
              iconColor="success"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Notifications"
              description="Our platform provides real time notifiction whenever a user post new content."
              icon={NotificationsNoneIcon}
              iconColor="danger"
              vertical
            />
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
